<template>
  <div>
    <ConfirmationDialog ref="confirm" :function-yes="bindingFunction" :text="confirmationText"></ConfirmationDialog>
    <v-btn color="#1787c9" class="white--text" :disabled="!canSubmit" @click="presentar">Presentar</v-btn>
    <v-tooltip bottom>
      <v-btn slot="activator" icon @click="deleteDraft"><v-icon>delete</v-icon></v-btn>
      <span>Descartar actualización en progreso</span>
    </v-tooltip>
  </div>
</template>

<script>
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'

export default {
  props: {
    canSubmit: Boolean,
    temporada: Number,
    descripcion: String,
    draftIds: []
  },

  components: {
    ConfirmationDialog
  },

  data () {
    return {
      bindingFunction: null,
      confirmationText: ''
    }
  },

  methods: {
    presentar () {
      this.confirmationText = '¿Presentar actualización en curso?'
      this.bindingFunction = () => {
        this.axios
          .post(`/draft/submit/${this.temporada}`, {
            'descripcion': this.descripcion,
            'draft_ids': this.draftIds
          })
          .then(() => {
            this.$store.commit('setDraft', null)
            this.$router.push({ name: 'actualizaciones' })
          })
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      }
      this.$refs.confirm.openDialog()
    },
    deleteDraft () {
      this.confirmationText = '¿Eliminar actualización en curso?'
      this.bindingFunction = () => {
        this.axios
          .delete('/draft/delete', {
            data: {
              draft_ids: this.draftIds
            }
          })
          .then(() => {
            this.$store.commit('setDraft', null)
            this.$router.push({ name: 'actualizaciones' })
          })
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      }
      this.$refs.confirm.openDialog()
    }
  }
}
</script>
